import { render, staticRenderFns } from "./CompanySettingField.vue?vue&type=template&id=feb8c4e6"
import script from "./CompanySettingField.vue?vue&type=script&lang=js"
export * from "./CompanySettingField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports